<template>
  <div class="yx-operation-guide-page main-layout">
    <el-card class="box-inner">
      <c-title slot="header" title="操作指南" :back="true"></c-title>
      <div class="div-scroll">
        <div class="content">
          <p class="card-title" style="text-align: center">迎新系统操作指南</p>
          <p class="card-content">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我校今年实行网上迎新，请新生务必于学校规定时间内登陆网上迎新系统，并按相关流程和要求完成网上填报手续。
          </p>
          <p class="card-subtitle">1.电脑登录：</p>
          <p class="card-content">
            (1) 在浏览器中输入https://stu.hbut.edu.cn/manage/welcome/进入迎新系统。
          </p>
          <p class="card-content">(2) 输入账号和密码进入迎新系统。</p>
          <p class="card-content">
            (3) 点击“入学须知”一栏，查看新生入学须知。
          </p>
          <p class="card-content">
            (4) 点击“个人资料”一栏，在规定时间内完成所有个人信息填写，其中包括：基础信息、学习经历、家庭成员、奖励处分等。
          </p>
          <p class="card-content">
            (5) 点击“我的老师”一栏，进入我的老师页，可查看我的老师信息。
          </p>
          <p class="card-content">
            (6)点击“入学测试”一栏，首先点击入学资料认真学习，然后完成相应的学习测试并提交。
          </p>
          <p class="card-content">
            (7)
            点击“预报到”一栏，进入预报到页面，逐步完成预报到事项，全部完成后即可进行现场迎新事项。
          </p>
          <p class="card-content">(8) 点击“我的宿舍”一栏，可查看宿舍相关信息。</p>
          <p class="card-content">
            (9) 击“现场迎新”一栏，可查看现场迎新相关事项、办理地点以及事项完成状态。
          </p>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import CTitle from "@/components/CTitle";
export default {
  components: {
    CTitle,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
};
</script>
